import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/dae3hbbep053ijub1820";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // 蜜罐字段若被填写，则不提交并给出与成功一致的反馈
    const honey = (fd.get("website_alt") as string)?.trim() || "";
    if (honey) {
      setStatus("success");
      form.reset();
      return;
    }

    // 构造提交数据，排除蜜罐
    const payload = new URLSearchParams();
    const email = (fd.get("email") as string) || "";
    payload.append("email", email);

    setStatus("idle");
    try {
      const response = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, any> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const okCode = parsed?.code === "OK";

      if (response.ok && okCode && !/spam/i.test(serverMsg)) {
        setStatus("success");
        form.reset();
      } else {
        const msg =
          typeof serverMsg === "string" && serverMsg.trim()
            ? serverMsg
            : "订阅失败，请稍后再试，或直接通过邮箱联系我们。";
        setFormError(msg);
        setStatus("error");
      }
    } catch {
      setFormError("网络似乎开小差了，请稍后再试。");
      setStatus("error");
    }
  };

  return (
    <section id="subscribe" className="relative w-full overflow-hidden bg-foreground-950 py-14 md:py-20">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20golden%20texture%20with%20soft%20light%20rays%20and%20bokeh%20particles%20on%20a%20deep%20warm%20charcoal%20background%2C%20cinematic%20ambient%20glow%2C%20amber%20orange%20tones&width=1600&height=760&seq=subscribe-bg-2026&orientation=landscape"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-center opacity-60"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/70 to-foreground-950/90"></div>

      <div className="relative mx-auto flex w-full max-w-[1320px] flex-col items-center px-4 text-center md:px-6">
        <span className="flex items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/15 px-4 py-1.5 text-xs font-medium text-accent-200">
          <i className="ri-megaphone-line"></i> 前排订阅，热点不缺席
        </span>
        <h2 className="mt-5 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
          留下邮箱，第一时间站上热搜风向
        </h2>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-200 md:text-base">
          订阅看料门每日围观简报，热门名场面与热议风向在每天早晚准时送达，不错过任何一场精彩现场。
        </p>

        <form onSubmit={handleSubmit} data-readdy-form className="mt-8 w-full max-w-xl">
          <div className="hp-guard" aria-hidden="true">
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" readOnly />
          </div>
          {status === "success" ? (
            <div className="rounded-2xl border border-accent-500/40 bg-accent-500/15 px-6 py-5 text-sm text-accent-100">
              <i className="ri-checkbox-circle-line mr-2 text-lg"></i>
              订阅成功！看料门的热点简报很快就到，记得留意收件箱。
            </div>
          ) : (
            <>
              <div className="flex flex-col gap-3 sm:flex-row">
                <label className="relative flex-1 text-left">
                  <i className="ri-mail-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-500"></i>
                  <input
                    type="email"
                    name="email"
                    required
                    autoComplete="email"
                    placeholder="输入你的常用邮箱"
                    className="w-full rounded-full border border-background-200 bg-background-50 py-3.5 pl-12 pr-4 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-300/40"
                  />
                </label>
                <button
                  type="submit"
                  className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
                >
                  前排订阅
                </button>
              </div>
              {status === "error" && (
                <p className="mt-3 flex items-center justify-center gap-1.5 text-sm text-accent-400">
                  <i className="ri-error-warning-line"></i>
                  {formError}
                </p>
              )}
            </>
          )}
        </form>
        <p className="mt-4 text-xs text-foreground-400">订阅即表示同意接收看料门资讯邮件，可随时退订。</p>
      </div>
    </section>
  );
}